import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAuditDto } from '../../models/IAuditDto';
import { baseService } from '../base.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuditInfrastructureService extends baseService {

  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  private apiRoute: string = '';

  async createAuditDatabase(auditDto: IAuditDto) {
    this.apiRoute = 'auditinfrastructure';
    return this.post(`/${this.apiRoute}`, auditDto).toPromise();
  }

  async createAuditDatabaseWithPartitions(auditDto: IAuditDto) {
    this.apiRoute = 'auditinfrastructure/partition';
    return this.post(`/${this.apiRoute}`, auditDto).toPromise();
  }

  async syncAuditDatabase(profileId: string) {
    this.apiRoute = `auditinfrastructure/${profileId}/sync`;
    return this.get(`/${this.apiRoute}`).toPromise();
  }

  async syncAuditDatabaseColumns(profileId: string) {
    this.apiRoute = `auditinfrastructure/${profileId}/sync/columns`;
    return this.get(`/${this.apiRoute}`).toPromise();
  }
}
